module.exports = __webpack_public_path__ + "assets/images/EU-Capital-Field-BG.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/EU-Capital-Field-BG.jpg
 ** module id = 31
 ** module chunks = 0
 **/